angular.module('routes.magic.MagicController', [
])

/**
 * The MagicController manages view logic rendered to the
 * case.html template for the /case view.
 *
 * @class MagicController
 * @constructor
 * @module routes.magic.MagicController
 */
.controller('MagicController', [
  '$scope',
  '$rootScope',
  '$state',
  'CasesService',
  function ($scope, $rootScope, $state, CasesService) {
    'use strict';

    $scope.state = $state;

    /**
     * Method executes the initialization process.
     *
     * @private
     */
    function initialize() {
      $scope.magicSave = function () {
        console.log('MagicController: Magic Save!');
        $rootScope.loadingDisabled = true;
        CasesService.queue = _.cloneDeep(CasesService.get());
        $state.go(
          'routes.cases.states',
          {
            caseId: CasesService.queue[0].id,
            stateId: CasesService.queue[0].content.start,
            stateMode: 'edit'
          }
        );
      };
    }
    initialize();
  }
]);
